// MB-I18N-2A — app EN (extrait de LanguageContext, valeurs inchangées).
export default {
  "nav.account": "Account",
  "nav.wallet": "Wallet",
  "nav.menu": "Menu",
  "nav.location": "Location",
  "nav.cart": "Cart",
  "nav.home": "Home",
  "nav.order": "Order",
  "nav.pay": "Pay",
  "nav.news": "News",
  "nav.stores": "Stores",
  "news.title": "News",
  "news.heading": "SUPERKAWA News",
  "news.coming_soon_title": "Coming soon",
  "news.coming_soon_desc": "News, promotions, events and messages from your shops will appear here very soon.",
  "news.notify_hint": "You’ll be notified at launch",
  "news.empty_feed": "No news available at the moment.",
  "news.empty_feed_hint": "News and promotions from your shops will appear here.",
  "news.back_home": "Back to home",
  "account.good_morning": "Good morning",
  "account.good_afternoon": "Good afternoon",
  "account.good_evening": "Good evening",
  "account.loyalty_points": "Loyalty Points",
  "account.points": "points",
  "account.points_to_free": "points to free drink",
  "account.free_drinks": "You have {count} free drink(s)!",
  "account.welcome_offer": "Welcome Offer",
  "account.welcome_offer_progress": "Spend {amount} DA more for a free coffee!",
  "account.history": "History",
  "account.favorites": "Favorites",
  "account.support": "Support",
  "account.settings": "Settings",
  "account.recent_orders": "Recent Orders",
  "account.sign_out": "Sign Out",
  "account.items": "item(s)",
  "menu.title": "Menu",
  "menu.our_menu": "Our menu",
  "menu.discover": "Discover our premium selection",
  "menu.espresso": "Espresso",
  "menu.coldbrew": "Cold Brew",
  "menu.froid": "Cold",
  "menu.cookies": "Cookies",
  "menu.hot": "Hot",
  "menu.chaud": "Hot",
  "menu.price_todefine": "Price to be set",
  "menu.cold": "Cold",
  "menu.snacks": "Snacks",
  "menu.packs": "Packs",
  "menu.size": "Size",
  "menu.option": "Option",
  "menu.vanilla_ice_cream": "Vanilla ice cream",
  "menu.view_recipe": "View recipe",
  "menu.recipe": "Recipe",
  "menu.recipe_difficulty": "Difficulty",
  "menu.recipe_ingredients": "Ingredients",
  "menu.recipe_steps": "Steps",
  "menu.recipe_tip": "Tip",
  "menu.recipe_loading": "Loading…",
  "menu.recipe_unavailable": "Recipe unavailable",
  "menu.recipe_close": "Close",
  "menu.quantity": "Quantity",
  "menu.add_to_cart": "Add to Cart",
  "menu.add": "Add",
  "menu.view_cart": "View cart",
  "menu.items_in_cart": "item(s)",
  "menu.estimated_prep": "Estimated prep: ~10 mins",
  "menu.added_to_cart": "Added to cart",
  "menu.coffees_included": "coffees included",
  "menu.cash_only": "Purchase at counter • Cash payment only",
  "menu.save": "Save",
  "menu.no_products": "No products available",
  "menu.load_error": "Failed to load menu",
  "menu.choose_shop_first": "Choose an establishment first",
  "menu.pause_salat": "Prayer Break",
  "menu.pause_salat_msg": "We will resume service in a few minutes",
  "menu.pause_simple": "Store on break",
  "menu.pause_simple_msg": "We will resume shortly",
  "menu.status_closed": "Store closed",
  "menu.status_closed_msg": "This establishment is currently closed",
  "menu.status_maintenance": "Maintenance in progress",
  "menu.status_maintenance_msg": "This establishment is temporarily unavailable",
  "menu.status_suspended": "Store unavailable",
  "menu.status_suspended_msg": "This establishment is not accepting orders right now",
  "menu.status_until": "Expected to resume",
  "shop.choose_title": "Choose your store",
  "shop.country_dz": "Algeria",
  "shop.country_fr": "France",
  "shop.country_ma": "Morocco",
  "shop.country_sa": "Saudi Arabia",
  "order.received_title": "Order received",
  "order.received_msg": "Your order has been received and will be processed shortly.",
  "order.preparing_title": "In preparation",
  "order.preparing_msg": "Your order is being prepared.",
  "order.ready_title": "Order ready!",
  "order.ready_msg": "Come to the counter to pick up your order.",
  "order.step_received": "Received",
  "order.step_preparing": "Preparing",
  "order.step_ready": "Ready",
  "order.number": "No.",
  "order.total": "Total",
  "order.subtotal_ht": "Subtotal (excl. VAT)",
  "order.vat": "VAT",
  "order.total_ttc": "Total (incl. VAT)",
  "order.pickup": "Pickup",
  "order.estimated_time": "Estimated time",
  "order.refresh_status": "Refresh status",
  "order.new_order": "New order",
  "order.points_earned": "+{points} points earned",
  "home.hello": "Hello",
  "home.welcome_back": "Welcome back",
  "home.loyalty_member": "Loyalty member",
  "home.points_subtitle": "Earn points on every visit",
  "home.view_wallet": "View my wallet",
  "home.your_shop": "Your shop",
  "home.choose_shop": "Choose a shop",
  "home.no_shop_desc": "Select a shop to get started",
  "home.shop_active": "Open",
  "home.shop_inactive": "Unavailable",
  "home.my_account": "My account",
  "home.qr_subtitle": "Show this code at the counter",
  "home.next_reward_cta": "View rewards",
  "home.recent_activity": "Recent activity",
  "home.view_all": "View all",
  "home.no_rewards": "No rewards available for this shop",
  "home.no_activity": "No recent activity",
  "location.title": "Our Locations",
  "location.open": "Open",
  "location.closed": "Closed",
  "location.closed_today": "Closed today",
  "location.hours": "Opening Hours",
  "location.no_stores": "No stores available",
  "location.near_me": "Stores near me",
  "location.nearest": "Nearest",
  "location.locating": "Locating…",
  "location.location_denied": "Location unavailable — pick your store",
  "location.directions": "Directions",
  "shop.detail_back": "Back",
  "shop.detail_back_explore": "Back to places",
  "shop.detail_notfound_title": "Place not found",
  "shop.detail_notfound_desc": "This place does not exist or is no longer available.",
  "shop.section_info": "Information",
  "shop.section_hours": "Opening hours",
  "shop.section_contact": "Contact",
  "shop.distance_from_you": "from your location",
  "shop.action_share": "Share",
  "shop.share_copied": "Link copied",
  "shop.share_failed": "Could not copy link",
  "shop.section_reviews": "Verified reviews",
  "shop.reviews_verified_badge": "Verified review",
  "shop.reviews_empty": "No reviews yet.",
  "shop.reviews_count_suffix": "verified reviews",
  "shop.reviews_count_suffix_one": "verified review",
  "shop.reviews_merchant_reply": "Owner reply",
  "shop.reviews_verified_note": "Every review comes from a real order placed at this venue.",
  "shop.reviews_anonymous": "Verified customer",
  "explore.search_placeholder": "Search by name, address, country…",
  "explore.no_results": "No place matches your search",
  "explore.view_menu": "View menu",
  "explore.results": "place(s)",
  "shop.country_sn": "Senegal",
  "shop.country_tn": "Tunisia",
  "shop.country_id": "Indonesia",
  "type.coffee_shop": "Coffee shop",
  "type.fast_food": "Fast food",
  "type.salon_de_the": "Tea house",
  "type.boulangerie": "Bakery",
  "type.restaurant": "Restaurant",
  "cart.title": "Your Cart",
  "cart.empty": "Your cart is empty",
  "cart.empty_subtitle": "Add items from the menu to get started",
  "cart.pickup_location": "Pickup Location",
  "cart.select_store": "Select a store",
  "cart.payment_method": "Payment Method",
  "cart.wallet": "Wallet",
  "cart.balance": "Balance",
  "cart.pay_counter": "Pay at Counter",
  "cart.cash": "Cash payment",
  "cart.insufficient_balance": "Insufficient wallet balance. Please recharge at the counter or select another payment method.",
  "cart.total": "Total",
  "cart.place_order": "Place Order",
  "cart.order_placed": "Order Placed!",
  "cart.order_received": "Your order {number} has been received",
  "cart.estimated_ready": "Estimated ready time",
  "cart.mins": "mins",
  "cart.points_earned": "Points earned",
  "cart.another_order": "Place Another Order",
  "cart.order_failed": "Failed to place order",
  "status.pending": "Pending",
  "status.preparing": "Preparing",
  "status.ready": "Ready",
  "status.completed": "Completed",
  "status.cancelled": "Cancelled",
  "loyalty.bronze": "Bronze",
  "loyalty.silver": "Silver",
  "loyalty.gold": "Gold",
  "loyalty.member": "Member",
  "cart.empty_toast": "Your cart is empty",
  "cart.insufficient_short": "Insufficient balance",
  "cart.order_sent": "Order sent",
  "cart.order_error": "Error while placing order",
  "cart.change": "Change",
  "cart.choose_shop": "Choose a store",
  "cart.coming_soon_methods": "Coming soon",
  "cart.soon": "Soon",
  "pay.title": "Pay",
  "pay.subtitle": "Finalize your order",
  "pay.cart_empty": "Empty cart",
  "pay.add_from_menu": "Add items from the menu",
  "pay.view_menu": "View menu",
  "pay.choose_shop_title": "Choose a shop",
  "pay.choose_shop_subtitle": "Select your SUPERKAWA store to see available payment options.",
  "pay.your_cart": "Your cart ({count})",
  "pay.payment_method": "Payment method",
  "pay.insufficient_long": "Insufficient balance. Recharge your wallet or choose another payment method.",
  "pay.confirm_order": "Confirm order",
  "pay.balance": "Balance",
  "account.personal_info": "Personal information",
  "account.name": "Name",
  "account.phone": "Phone",
  "account.email": "Email",
  "account.security": "Security",
  "account.password": "Password",
  "account.security_pin": "Security PIN",
  "account.configure_pin": "Set up a PIN",
  "account.preferences": "Preferences",
  "account.language": "Language",
  "account.notifications": "Notifications",
  "account.notifications_on": "Enabled",
  "account.notifications_off": "Disabled",
  "account.help": "Help and support",
  "account.assistance": "Assistance",
  "account.danger_zone": "Danger zone",
  "account.delete_account": "Delete my account",
  "account.delete_warning": "This action is irreversible",
  "account.logout": "Log out",
  "account.app_version": "SUPERKAWA® v1.0.0",
  "account.not_set": "Not set",
  "account.edit_name": "Edit name",
  "account.edit_email": "Edit email",
  "account.change_password": "Change password",
  "account.current_password": "Current password",
  "account.new_password": "New password",
  "account.confirm_password": "Confirm password",
  "account.your_name_placeholder": "Your name",
  "account.email_placeholder": "your@email.com",
  "account.setup_pin_title": "Set up PIN",
  "account.setup_pin_desc": "Create a 4-digit PIN to secure your payments.",
  "account.delete_title": "Delete account",
  "account.delete_confirm_msg": "Are you sure you want to delete your account? This action is irreversible and you will lose:",
  "account.delete_loss_balance": "Your wallet balance",
  "account.delete_loss_points": "Your loyalty points",
  "account.delete_loss_history": "Your order history",
  "account.delete_btn": "Delete",
  "account.modifications_saved": "Changes saved",
  "account.delete_support_msg": "Please contact support to delete your account",
  "account.support_msg": "Support: support@superkawa.co",
  "account.delete_confirm_title": "Confirm account deletion",
  "account.save_error": "Failed to save",
  "account.b2b.section_title": "Business invoicing",
  "account.b2b.label": "Business profiles (B2B)",
  "account.b2b.manage": "Manage my profiles",
  "account.b2b.empty": "No business profile yet. Add one for your B2B invoices.",
  "account.b2b.add": "Add a profile",
  "account.b2b.edit_title": "Edit profile",
  "account.b2b.create_title": "New business profile",
  "account.b2b.default_badge": "Default",
  "account.b2b.set_default": "Set as default",
  "account.b2b.legal_name": "Legal name",
  "account.b2b.country_code": "Registration country",
  "account.b2b.registration_number": "Registration number",
  "account.b2b.tax_identifier": "Tax identifier",
  "account.b2b.vat_identifier": "Intra-community VAT",
  "account.b2b.address_section": "Billing address",
  "account.b2b.street": "Street",
  "account.b2b.postal_code": "Postal code",
  "account.b2b.city": "City",
  "account.b2b.addr_country": "Country",
  "account.b2b.contact_section": "Contact",
  "account.b2b.contact_name": "Contact name",
  "account.b2b.contact_email": "Email",
  "account.b2b.contact_phone": "Phone",
  "account.b2b.set_as_default": "Default profile",
  "account.b2b.delete_confirm": "Delete this business profile?",
  "account.b2b.saved": "Profile saved",
  "account.b2b.deleted": "Profile deleted",
  "account.b2b.save_error": "Error saving",
  "account.b2b.load_error": "Error loading profiles",
  "orders.section_title": "Orders",
  "orders.section_subtitle": "View my past orders",
  "orders.title": "My orders",
  "orders.empty": "No orders yet.",
  "orders.prev": "Previous",
  "orders.next": "Next",
  "orders.status.pending": "Received",
  "orders.status.preparing": "Preparing",
  "orders.status.ready": "Ready",
  "orders.status.completed": "Completed",
  "orders.status.cancelled": "Cancelled",
  "orders.payment.paid": "Paid",
  "orders.payment.unpaid": "Unpaid",
  "orders.download_receipt": "Download receipt",
  "orders.download_invoice": "Download invoice",
  "orders.receipt_unavailable": "Receipt not available at the moment.",
  "orders.invoice_unavailable": "Invoice not available at the moment.",
  "orders.download_error": "Download error.",
  "reviews.my_reviews": "My reviews",
  "reviews.section_subtitle": "View the reviews I have left",
  "reviews.leave": "Leave a review",
  "reviews.already": "Review submitted",
  "reviews.dialog_title": "Leave a review",
  "reviews.your_rating": "Your rating",
  "reviews.your_comment": "Your comment",
  "reviews.comment_placeholder": "Share your experience (optional)",
  "reviews.submit": "Submit review",
  "reviews.submitted": "Review submitted. Thank you!",
  "reviews.error": "Error while submitting the review.",
  "reviews.rating_required": "Please select a rating.",
  "reviews.merchant_reply": "Merchant reply",
  "reviews.empty": "You have not left any reviews yet.",
  "reviews.status.published": "Published",
  "reviews.status.hidden": "Hidden",
  // MB-I18N-5 — Onboarding tunnel (establishment creation)
  "onboarding.brand": "SUPERKAWA OS",
  "onboarding.steps.establishment": "Establishment",
  "onboarding.steps.needs": "Needs",
  "onboarding.steps.payment": "Payment",
  "onboarding.steps.recommendation": "Recommendation",
  "onboarding.needs.pos": "POS & Checkout",
  "onboarding.needs.loyalty": "Loyalty",
  "onboarding.needs.wallet": "Wallet",
  "onboarding.needs.recipes": "Recipe management & standardisation",
  "onboarding.needs.stock": "Inventory & stocktakes",
  "onboarding.payments.card": "Bank card",
  "onboarding.payments.transfer": "Bank transfer",
  "onboarding.toast.reco_error": "Unable to compute the recommendation right now",
  "onboarding.toast.markets_loading": "Loading countries…",
  "onboarding.toast.markets_error": "Country catalog unavailable. Please try again.",
  "onboarding.errors.market_not_supported": "The {country_code} market is not supported yet.",
  "onboarding.toast.name_required": "Please enter the establishment name",
  "onboarding.toast.type_required": "Please select the establishment type",
  "onboarding.toast.specialty_required": "Please choose a specialty for your restaurant",
  "onboarding.toast.country_required": "Please select your country",
  "onboarding.toast.address_required": "Please enter the establishment address",
  "onboarding.toast.email_required": "Please enter the business email",
  "onboarding.toast.email_invalid": "Please enter a valid business email",
  "onboarding.toast.phone_required": "Please enter the business phone",
  "onboarding.toast.manager_required": "Please enter the name of the legal manager / owner",
  "onboarding.toast.fields_required": "Please complete the required fields (*)",
  "onboarding.toast.created": "Location \"{name}\" created in trial period.",
  "onboarding.toast.create_error": "Error while creating the location",
  "onboarding.step1.title": "Your establishment",
  "onboarding.step1.name_label": "Establishment name",
  "onboarding.step1.name_placeholder": "Le Petit Kawa",
  "onboarding.step1.type_label": "Establishment type",
  "onboarding.step1.types_loading": "Loading types…",
  "onboarding.step1.types_error": "Unable to load establishment types.",
  "onboarding.step1.retry": "Retry",
  "onboarding.step1.specialty_label": "Restaurant specialty",
  "onboarding.step1.service_mode_label": "How would you like to organise your point of sale?",
  "onboarding.step1.service_single_title": "A single register",
  "onboarding.step1.service_single_desc": "The whole service from a single terminal.",
  "onboarding.step1.service_prep_title": "Register + preparation screen",
  "onboarding.step1.service_prep_desc": "The register takes payment. A dedicated screen shows the orders to prepare.",
  "onboarding.step1.recommended": "Recommended",
  "onboarding.step1.country_label": "Country",
  "onboarding.step1.markets_loading": "Loading countries…",
  "onboarding.step1.markets_error": "Country catalog unavailable. Cannot continue without a country.",
  "onboarding.step1.country_placeholder": "Select your country",
  "onboarding.step1.address_label": "Address",
  "onboarding.step1.address_placeholder": "12 rue des Oliviers, Alger",
  "onboarding.step1.phone_label": "Business phone",
  "onboarding.step1.phone_placeholder": "+213 661 00 00 00",
  "onboarding.step1.email_label": "Business email",
  "onboarding.step1.email_placeholder": "contact@your-establishment.com",
  "onboarding.step1.manager_label": "Legal manager / owner name",
  "onboarding.step1.manager_placeholder": "First and last name of the legal manager",
  "onboarding.step1.regnum_label": "Business registration number",
  "onboarding.step1.regnum_placeholder": "RC / SIRET / NIF…",
  "onboarding.step2.title": "Your needs",
  "onboarding.step2.subtitle": "Select what matters for your business.",
  "onboarding.step3.title": "Preferred payment",
  "onboarding.step3.subtitle": "How would you like to pay for your subscription?",
  "onboarding.step4.title": "Our recommendation",
  "onboarding.step4.reco_loading": "Calculating…",
  "onboarding.step4.reco_badge": "Recommended plan",
  "onboarding.step4.trial_note": "Your location starts with a trial period. You can adjust your plan at any time.",
  "onboarding.nav.back": "Back",
  "onboarding.nav.continue": "Continue",
  "onboarding.nav.create": "Create my location",
  "onboarding.market_activation.message": "Would you like to activate your country? Contact SUPERKAWA. Activation can be done immediately.",
  "onboarding.market_activation.contact": "Contact SUPERKAWA",
  // MB-I18N-BACKEND-1 — Recommendation (backend codes translated on the frontend)
  "onboarding.pricing.per_month": "/ month",
  "onboarding.reco_explanation.needs_covered_by_plan": "Your needs are covered by the {plan} plan (customer app, POS, wallet & loyalty).",
  "onboarding.reco_explanation.recipes_need_pro": "Recipe standardisation requires the {plan} plan.",
  "onboarding.reco_explanation.stock_needs_full": "Inventory management requires the {plan} plan.",
  "onboarding.reco_explanation.unknown": "Plan recommended based on your needs.",
  "onboarding.establishment_types.coffee_shop": "Coffee Shop",
  "onboarding.establishment_types.salon_de_the": "Tea Room",
  "onboarding.establishment_types.boulangerie": "Bakery",
  "onboarding.establishment_types.restaurant": "Restaurant",
  "onboarding.establishment_types.unknown": "Establishment",
  "onboarding.specialties.pizza": "Pizza",
  "onboarding.specialties.burger": "Burger",
  "onboarding.specialties.kebab": "Kebab",
  "onboarding.specialties.poulet": "Chicken",
  "onboarding.specialties.sushi": "Sushi",
  "onboarding.specialties.poke": "Poké",
  "onboarding.specialties.salades": "Salads",
  "onboarding.specialties.japonais": "Japanese (Ramen & Dishes)",
  "onboarding.specialties.chinois": "Chinese",
  "onboarding.specialties.vietnamien": "Vietnamese",
  "onboarding.specialties.thai": "Thai",
  "onboarding.specialties.indien": "Indian",
  "onboarding.specialties.pakistanais": "Pakistani",
  "onboarding.specialties.libanais": "Lebanese",
  "onboarding.specialties.italien": "Italian",
  "onboarding.specialties.mexicain": "Mexican",
  "onboarding.specialties.africain": "African",
  "onboarding.specialties.vegetarien": "Vegetarian",

  // MB-I18N-CLIENT-EXTRAS — Online top-up (Wallet)
  "onlineRecharge.title": "Online top-up",
  "onlineRecharge.current_balance": "Current balance",
  "onlineRecharge.choose_amount": "Choose amount",
  "onlineRecharge.custom_amount": "Or enter a custom amount",
  "onlineRecharge.minimum": "Minimum: {amount}",
  "onlineRecharge.min_amount_toast": "Minimum amount: {amount}",
  "onlineRecharge.amount_to_recharge": "Amount to top up",
  "onlineRecharge.proceed": "Proceed to payment",
  "onlineRecharge.card_soon_info": "Card payment will be available soon. To top up now, visit the shop.",
  "onlineRecharge.create_error": "Error while creating the payment",
  "onlineRecharge.pending_title": "Payment pending",
  "onlineRecharge.pending_desc": "Your top-up request has been recorded. Card payment will be available soon.",
  "onlineRecharge.reference": "Reference",
  "onlineRecharge.amount": "Amount",
  "onlineRecharge.status": "Status",
  "onlineRecharge.status_pending": "Awaiting payment",
  "onlineRecharge.pending_info": "Card payment (CIB/Edahabia/Stripe) will be enabled soon. In the meantime, you can top up at the shop with the staff.",
  "onlineRecharge.success_title": "Payment successful!",
  "onlineRecharge.success_desc": "Your wallet has been topped up",
  "onlineRecharge.new_balance": "New balance",
  "onlineRecharge.new_recharge": "New top-up",
  "onlineRecharge.back_to_wallet": "Back to wallet",
  "onlineRecharge.failed_title": "Payment failed",
  "onlineRecharge.failed_desc": "The payment could not be processed",
  "onlineRecharge.retry": "Try again",

  // MB-I18N-CLIENT-EXTRAS — Preparation screen (KDS)
  "preparation.title": "Preparation screen",
  "preparation.badge": "PREPARATION",
  "preparation.no_shop": "No shop selected.",
  "preparation.back_to_register": "Back to Register",
  "preparation.refresh": "Refresh",
  "preparation.register": "Register",
  "preparation.col_pending": "New",
  "preparation.col_preparing": "Preparing",
  "preparation.col_ready": "Ready",
  "preparation.action_prepare": "Prepare",
  "preparation.action_ready": "Ready",
  "preparation.action_finish": "Finish",
  "preparation.payment_required": "Payment required",
  "preparation.payment_required_hint": "Collect payment at the register before completing",
  "preparation.empty": "No order",
  "preparation.loyalty_customer": "Loyalty customer",
  "preparation.counter": "Counter",
  "preparation.no_items": "No item",
  "preparation.total": "Total",
  "preparation.toast_completed_points": "Order completed! +{points} loyalty points",
  "preparation.toast_updated": "Order updated",
  "preparation.toast_update_error": "Update error",
};
